import { luscinia } from '../luscinia';
import { getFormObject } from './modal';
import reloadBootgrids from '../Bootgrid/reload-bootgrids';

luscinia.closeModal = function (showConfirmation = false) {
    var currentModal = luscinia.getCurrentModal();
    if (showConfirmation && formHasChanged(currentModal.find('form'))) {
        luscinia.showConfirmationDialog('Are you sure?', 'The changes you made will be lost.', function (e) {
            currentModal.on('hidden.bs.modal', function (e) {
                currentModal.closest('.edit-modal').remove();
            });
            luscinia.getCurrentModal().modal('hide');
            reloadBootgrids();
        });
        return;
    }

    currentModal.on('hidden.bs.modal', function (e) {
        currentModal.closest('.edit-modal').remove();
    });
    luscinia.getCurrentModal().modal('hide');
    luscinia.getCurrentModal().find("form").removeAttr("loaded");
    reloadBootgrids();
};

luscinia.cancelInlineRecord = function (showConfirmation = false) {
    if (showConfirmation && formHasChanged($('#editModal0Form') as JQuery<HTMLFormElement>)) {
        luscinia.showConfirmationDialog('Are you sure?', 'The changes you made will be lost.', function (e) {
            luscinia.editModalFormCancel();
        });
        return;
    }
    luscinia.editModalFormCancel();
}

export function formHasChanged(form: JQuery<HTMLFormElement>): boolean {
    const currentFormId = form.attr('id');
    const savedFormData = localStorage.getItem(`formData-${currentFormId}`);

    const savedFormObj = JSON.parse(savedFormData) as object;
    const currentFormObj = getFormObject(luscinia.serializeFormObject(form));
    return !areObjectsEqual(savedFormObj, currentFormObj);
}

function areObjectsEqual(obj1: object, obj2: object): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2) 
}

function recordHasChanged(currentModal: JQuery<HTMLElement>): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
        var formData = luscinia.serializeFormObject(currentModal.find('form'));
        var url = `${currentModal.find('form').data(luscinia.data.modulePath)}/has-changed/${currentModal.find('form').data(luscinia.data.recordId)}`;
        $.ajax({
            method: 'post',
            url: url,
            data: formData,
            contentType: false,
            processData: false,
            cache: false,
            success: function (data: boolean) {
                resolve(data);
            },
            error: function () {
                resolve(true);
            },
        });
    });
}
